var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKbShield(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M52.3202 7.83744C52.2196 7.11542 51.7001 6.5215 50.9979 6.32629L28.4905 0.0669804C28.1696 -0.0223268 27.8307 -0.0223268 27.5096 0.0669804L5.00223 6.32629C4.29997 6.5215 3.78048 7.11517 3.67994 7.83744C3.5494 8.77614 0.571274 30.9556 8.20997 41.9891C15.8396 53.0096 27.095 55.8337 27.5704 55.9486C27.7116 55.9828 27.8556 55.9996 28 55.9996C28.1445 55.9996 28.2885 55.9826 28.4298 55.9486C28.9053 55.8337 40.1607 53.0096 47.7901 41.9891C55.4288 30.9558 52.4507 8.77638 52.3202 7.83744ZM42.5144 20.786L27.1621 36.1383C26.8049 36.4955 26.3364 36.6744 25.8681 36.6744C25.3999 36.6744 24.9314 36.4958 24.5742 36.1383L15.082 26.6461C14.7387 26.303 14.5459 25.8375 14.5459 25.3521C14.5459 24.8668 14.7389 24.4012 15.082 24.0582L16.9667 22.1734C17.6814 21.459 18.8402 21.4587 19.5547 22.1734L25.8681 28.4869L38.0417 16.3131C38.3848 15.9698 38.8504 15.777 39.3357 15.777C39.821 15.777 40.2866 15.9698 40.6297 16.3131L42.5144 18.1978C43.2291 18.9125 43.2291 20.0713 42.5144 20.786Z",
    fill: "#C32A7C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKbShield);
export default __webpack_public_path__ + "static/media/kb_shield.79a6e57dedb756f89872d29f94aec930.svg";
export { ForwardRef as ReactComponent };